<div class="container">
    <header>
        <h1>Choose the Right Plan for You</h1>
        <p class="subtitle">Get access to all our premium features with flexible pricing options designed to fit your needs.</p>
        <!--
        <div class="billing-toggle">
            <span class="toggle-label" id="monthlyLabel">Monthly</span>
            <label class="toggle-switch">
                <input type="checkbox" id="billingToggle" [(ngModel)]="billingToggle">
                <span class="toggle-slider"></span>
            </label>
            <span class="toggle-label active" id="yearlyLabel">Yearly <span class="save-badge">Save 20%</span></span>
        </div>
        -->
    </header>

    <div class="pricing-plans">
        <!-- Basic Plan -->
        <div class="pricing-card" *ngFor="let product of products; let i = index" [ngClass]="{ 'popular': products[i] === product }">
            <div class="popular-badge" *ngIf="products[i] === product">Most Popular</div>
            <div class="plan-name">Basic</div>
            <div class="plan-price" id="basicPrice">{{ (product.amount / 100) | currency }} <span>/{{ product.interval }}</span></div>
            <!--
            <div class="plan-billing" id="basicBilling">Billed yearly ($119.88)</div>
            -->
            <p class="plan-description">{{ product.description }}</p>
            
            <ul class="feature-list">
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Access to basic features</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Basic calculations</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Basic product data from multiple platforms</div>
                </li>
                <!--
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Email support</div>
                </li>
                -->
                <li>
                    <div class="feature-icon excluded">×</div>
                    <div class="feature-text excluded">Priority support</div>
                </li>
                <li>
                    <div class="feature-icon excluded">×</div>
                    <div class="feature-text excluded">Advanced analytics</div>
                </li>
                <!--
                <li>
                    <div class="feature-icon excluded">×</div>
                    <div class="feature-text excluded">Custom branding</div>
                </li>
                -->
            </ul>
            
            <button class="cta-button btn-outline" [routerLink]="['/register']">Register</button>
        </div>

        <!-- Pro Plan
        <div class="pricing-card popular">
            <div class="popular-badge">Most Popular</div>
            <div class="plan-name">Pro</div>
            <div class="plan-price" id="proPrice">$19.99 <span>/mo</span></div>
            <div class="plan-billing" id="proBilling">Billed yearly ($239.88)</div>
            <p class="plan-description">Ideal for professionals and small teams looking for more power.</p>
            
            <ul class="feature-list">
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Access to all basic features</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Up to 10 projects</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">10GB storage</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Email support</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Priority support</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Advanced analytics</div>
                </li>
                <li>
                    <div class="feature-icon excluded">×</div>
                    <div class="feature-text excluded">Custom branding</div>
                </li>
            </ul>
            
            <button class="cta-button btn-primary">Get Started</button>
        </div>
        -->

        <!-- Enterprise Plan
        <div class="pricing-card">
            <div class="plan-name">Enterprise</div>
            <div class="plan-price" id="enterprisePrice">$49.99 <span>/mo</span></div>
            <div class="plan-billing" id="enterpriseBilling">Billed yearly ($599.88)</div>
            <p class="plan-description">For large teams and organizations with advanced needs.</p>
            
            <ul class="feature-list">
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Access to all features</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Unlimited projects</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">100GB storage</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Email support</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">24/7 priority support</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Advanced analytics</div>
                </li>
                <li>
                    <div class="feature-icon included">✓</div>
                    <div class="feature-text">Custom branding</div>
                </li>
            </ul>
            
            <button class="cta-button btn-outline">Get Started</button>
        </div>
        -->
    </div>

    <!--
    <a href="#" class="comparison-link">View full feature comparison →</a>
    -->
    <div class="guarantee">
        <h3 class="guarantee-title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            30-Day Free Trial
        </h3>
        <p class="guarantee-text">
            Try any plan risk-free 30 day free trial, no card required to start.
        </p>
    </div>

    <div class="faq-section">
        <h2 class="section-title">Frequently Asked Questions</h2>
        
        <div class="faq-item" [class.active]="activeFaqIndex === 0" (click)="toggleFaq(0)">
            <div class="faq-question">What payment methods do you accept?</div>
            <div class="faq-answer" [class.active]="activeFaqIndex === 0">
                <p>We accept all major credit cards including Visa, Mastercard, American Express, and Discover for convenient checkout.</p>
            </div>
        </div>
        
        <div class="faq-item" [class.active]="activeFaqIndex === 1" (click)="toggleFaq(1)">
            <div class="faq-question">Can I switch plans later?</div>
            <div class="faq-answer" [class.active]="activeFaqIndex === 1">
                <p>Currently we only offer one subscription plan.</p>
            </div>
        </div>
        
        <div class="faq-item" [class.active]="activeFaqIndex === 2" (click)="toggleFaq(2)">
            <div class="faq-question">How does the yearly billing discount work?</div>
            <div class="faq-answer" [class.active]="activeFaqIndex === 2">
                <p>As of now there are only monthly subcriptions offered, but yearly subscribtions may bbe offered in the future.</p>
            </div>
        </div>
        
        <div class="faq-item" [class.active]="activeFaqIndex === 3" (click)="toggleFaq(3)">
            <div class="faq-question">What happens when my trial ends?</div>
            <div class="faq-answer" [class.active]="activeFaqIndex === 3">
                <p>When your trial period ends, you will need to provide billing information, your account will then automatically be converted to the plan you selected. You won't lose any data or settings during this transition. We'll send you a reminder email before your trial expires.</p>
            </div>
        </div>
        
        <div class="faq-item" [class.active]="activeFaqIndex === 4" (click)="toggleFaq(4)">
            <div class="faq-question">Do you offer discounts for nonprofits or educational institutions?</div>
            <div class="faq-answer" [class.active]="activeFaqIndex === 4">
                <p>At the moment there are no discount offers for groups or institutions. Please contact our sales team for more information about our discount programs.</p>
            </div>
        </div>
    </div>

    <!--
    <div class="testimonials">
        <h2 class="section-title">What Our Customers Say</h2>
        
        <div class="testimonial-card">
            <p class="testimonial-text">
                "This platform has completely transformed how our team collaborates. The Pro plan gives us everything we need at a price that makes sense for our growing business. The support team is incredibly responsive too!"
            </p>
            <div class="testimonial-author">
                <div class="author-avatar">
                    <img src="https://i.pravatar.cc/100?img=33" alt="Sarah Johnson">
                </div>
                <div class="author-info">
                    <h4>Sarah Johnson</h4>
                    <p>Marketing Director, TechFlow Inc.</p>
                </div>
            </div>
        </div>
    </div>
    -->

    <div class="footer">
        <p>Have questions? <a [routerLink]="['/contact']">Contact our sales team</a></p>
    </div>
</div>